import { FatDoctoUfPercurso } from './../interfaces/fat-docto-uf-percurso';
import { FatDoctoLocalCarga } from './../interfaces/fat-docto-local-carga';
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { FatDoctoC } from '../interfaces/fat-docto-c';
import { FatDoctoCProjection } from '../interfaces/fat-docto-c-projection';
import { Observable } from 'rxjs';
import { PageResult } from '../interfaces/page-result';
import { FatDoctoI } from '../interfaces/fat-docto-i';
import { FatDoctoIProjection } from '../interfaces/fat-docto-i-projection';
import { FatDoctoRef } from '../interfaces/fat-docto-ref';
import { FatDoctoCCce } from '../interfaces/fat-docto-cc-ce';
import { JwtAuthService } from './auth/jwt-auth.service';
import { FinancRp } from '../interfaces/financ-rp';
import { FatDoctoAnttTipo } from '../interfaces/fat-docto-antt-tipo';

@Injectable({
  providedIn: 'root'
})
export class FatDoctoCService {


  readonly path = '/lancamento';


  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) {  }
  create(tipo= "LCTO"): Observable<FatDoctoC> {
    return this.http.post<FatDoctoC>(`${this.jwtAuthService.apiUrl + this.path}?tipoLcto=${tipo}`, null);
  }

  changeTransacao(fatDoctoC: FatDoctoC): Observable<FatDoctoC> {
    return this.http.put<FatDoctoC>(`${this.jwtAuthService.apiUrl + this.path}/change/transacao`, fatDoctoC);
  }

  saveOrUpdate(fatDoctoC: FatDoctoC): Observable<FatDoctoC> {
    console.log('saveOrUpdate', fatDoctoC);
    return this.http.put<FatDoctoC>(`${this.jwtAuthService.apiUrl + this.path}/web`, fatDoctoC);
  }
  
  finalizaPedido(controle: number): Observable<any> {
    return this.http.put<any>(`${this.jwtAuthService.apiUrl + this.path}/web/finaliza/${controle}`, null);
  }

  getFatDoctoC(id: number ): Observable<FatDoctoC> {
    return this.http.get<FatDoctoC>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }
  
  getPedidosAberto(): Observable<any> {
    return this.http.get<any>(`${this.jwtAuthService.apiUrl + this.path}/web/pedidos/abertos?loadLcto=true`);
  }

    
  getPedidosByUser(status: number[], page=1, size=10): Observable<PageResult<FatDoctoC>> {
    return this.http.get<PageResult<FatDoctoC>>(`${this.jwtAuthService.apiUrl + this.path}/web/pedidos?status=${status.join(',')}`
      +`&pageNumber=${(page??1)<=0?1:page}&size=${size}`);
  }


  idemFatDoctoC(controle: number ): Observable<FatDoctoC> {
    return this.http.get<FatDoctoC>(`${this.jwtAuthService.apiUrl + this.path}/idem/${controle}`);
  }

  agruparLancamentos(controles: number[], transacaoId: number): Observable<FatDoctoC> {
    return this.http.put<FatDoctoC>(`${this.jwtAuthService.apiUrl + this.path}/web/agrupar`, {
      controles,
      transacaoId,
    });
  }

  delete(controle: number): Observable<any> {
    return this.http.delete<any>(`${this.jwtAuthService.apiUrl + this.path}/${controle}`);
  }


  autoriza(controle: number ): Observable<FatDoctoC> {
    return this.http.get<FatDoctoC>(`${this.jwtAuthService.apiUrl + this.path}/autoriza/${controle}`)
  }

  autorizaNfe(controle: number ): Observable<FatDoctoC> {
    return this.http.get<FatDoctoC>(`${this.jwtAuthService.apiUrl + this.path}/nfe/autorizar/${controle}`)
  }

  // NFS-e (Padrão Nacional) — DPS montado server-side (sem corpo), espelhando o padrão do CT-e.
  autorizaNfse(controle: number ): Observable<FatDoctoC> {
    return this.http.get<FatDoctoC>(`${this.jwtAuthService.apiUrl + this.path}/nfse/autorizar/${controle}`)
  }

  cancelarNfse(controle: number, mv: string ): Observable<any> {
    const body = { motivo: mv };
    return this.http.post<any>(`${this.jwtAuthService.apiUrl + this.path}/nfse/cancelar/${controle}`, body)
  }

  consultarNfse(controle: number ): Observable<any> {
    return this.http.get<any>(`${this.jwtAuthService.apiUrl + this.path}/nfse/consultar/${controle}`)
  }

  autorizaMdfe(controle: number ): Observable<FatDoctoC> {
    return this.http.put<FatDoctoC>(`${this.jwtAuthService.apiUrl + this.path}/mdfe/autorizar/${controle}`, null)
  }

  cancelarMdfe(controle: number, mv: string ): Observable<any> {
    const body = { motivo:  mv};
    return this.http.post<any>(`${this.jwtAuthService.apiUrl + this.path}/mdfe/cancelar/${controle}`, body)
  }

  consultarMdfe(controle: number ): Observable<any> {
    return this.http.get<any>(`${this.jwtAuthService.apiUrl + this.path}/mdfe/consultar/${controle}`)
  }

  encerrarMdfe(controle: number ): Observable<any> {
    return this.http.get<any>(`${this.jwtAuthService.apiUrl + this.path}/mdfe/encerrar/${controle}`)
  }

  autorizaCte(controle: number ): Observable<FatDoctoC> {
    return this.http.put<FatDoctoC>(`${this.jwtAuthService.apiUrl + this.path}/cte/autorizar/${controle}`, null)
  }

  cancelarCte(controle: number, mv: string ): Observable<any> {
    const body = { motivo:  mv};
    return this.http.post<any>(`${this.jwtAuthService.apiUrl + this.path}/cte/cancelar/${controle}`, body)
  }

  consultarCte(controle: number ): Observable<any> {
    return this.http.get<any>(`${this.jwtAuthService.apiUrl + this.path}/cte/consultar/${controle}`)
  }

  previaCte(controle: number ): Observable<any> {
    // return this.http.get(`${this.jwtAuthService.apiUrl + this.path}/cte/previa/${controle}` , {responseType: 'arraybuffer'})
    return this.http.get(`${this.jwtAuthService.apiUrl + this.path}/previa/${controle}` , {responseType: 'arraybuffer'})
  }

  previaCteWithResponse(controle: number): Observable<HttpResponse<ArrayBuffer>> {
    return this.http.get(`${this.jwtAuthService.apiUrl + this.path}/previa/${controle}`, {
      responseType: 'arraybuffer',
      observe: 'response'
    });
  }

  cancelar(controle: number, mv: string ): Observable<any> {
    const body = { motivo:  mv};
    return this.http.post<any>(`${this.jwtAuthService.apiUrl + this.path}/cancelar/${controle}`, body)
  }


  consultar(controle: number ): Observable<any> {
    return this.http.get<any>(`${this.jwtAuthService.apiUrl + this.path}/consultar/${controle}`)
  }

  enviarEmail(controle: number, email: string ): Observable<any> {
    return this.http.get<any>(`${this.jwtAuthService.apiUrl + this.path}/email/${controle}?email=${email}`)
  }

  previa(controle: number ): Observable<any> {
    return this.http.get(`${this.jwtAuthService.apiUrl + this.path}/previa/${controle}` , {responseType: 'arraybuffer'})
  }

  previaWithResponse(controle: number): Observable<HttpResponse<ArrayBuffer>> {
    return this.http.get(`${this.jwtAuthService.apiUrl + this.path}/previa/${controle}`, {
      responseType: 'arraybuffer',
      observe: 'response'
    });
  }

  getFatDoctoCClean(id: number ): Observable<FatDoctoC> {
    return this.http.get<FatDoctoC>(`${this.jwtAuthService.apiUrl + this.path}/clean/${id}`);
  }

  printForm(controle: number , formId: number, onlyPrint = false): Observable<any> {
    return this.http.get(`${this.jwtAuthService.apiUrl + this.path}/print/${controle}/${formId}/${onlyPrint}`
    , {responseType: 'arraybuffer'});
  }

  /** Retorna o XML da NFe (string) para o controle informado */
  getNfeXml(controle: number): Observable<string> {
    return this.http.get(`${this.jwtAuthService.apiUrl + this.path}/nfe/xml/${controle}`, { responseType: 'text' });
  }

  getFatDoctoCPageEmail(dataInicial?: Date, dataFinal?: Date, page?: number, size?: number,
    order?: string, direction?: string): Observable<PageResult<FatDoctoC>> {
    return this.http.get<PageResult<FatDoctoC>>(`${this.jwtAuthService.apiUrl + this.path}/email/page/get?page=${(page??1)<=0?1:page}&size=`
      + `${size}&order=${order}&direction=${direction}&dataInicial=${dataInicial.toISOString()}&dataFinal=${dataFinal.toISOString()}&status=100,101,150,132,135,136,205,301,302,303`);
  }
 

  sendEmail(dataInicial?: Date, dataFinal?: Date, page?: number, size?: number, enviarPdf: boolean = false,
    remetente?: string, destinarios?: string): Observable<any> {
    return this.http.get<any>(`${this.jwtAuthService.apiUrl }/lcto/email/send/?page=${page}&size=`
      + `${size}&enviarPdf=${enviarPdf}&emails=${destinarios}&from=${remetente}&dataInicial=${dataInicial.toISOString()}&dataFinal=${dataFinal.toISOString()}&e=100,101,150,132,135,136,205,301,302,303`);
  }

  getFatDoctoCPage(dataInicial?: Date, dataFinal?: Date, page?: number, size?: number,
    order?: string, direction?: string): Observable<PageResult<FatDoctoC>> {
    return this.http.get<PageResult<FatDoctoC>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${(page??1)<=0?1:page}&size=`
     + `${size}&order=${order}&direction=${direction}&dataInicial=${dataInicial.toISOString()}&dataFinal=${dataFinal.toISOString()}`);
  }

  getFatDoctoCPageSearch(page?: number, size?: number,  search?: string, dataInicial?: Date, dataFinal?: Date,
    order?: string, direction?: string): Observable<PageResult<FatDoctoC>> {
    return this.http.get<PageResult<FatDoctoC>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${(page??1)<=0?1:page}&size=` +
    `${size}&search=${search}&order=${order}&direction=${direction}&dataInicial=${dataInicial.toISOString()}&dataFinal=${dataFinal.toISOString()}`);
  }

  getFatDoctoCProjectionPage(page?: number, size?: number, order?: string, direction?: string): Observable<PageResult<FatDoctoCProjection>> {
    return this.http.get<PageResult<FatDoctoCProjection>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/projection/?page=${(page??1)<=0?1:page}&size=`
     + `${size}&order=${order}&direction=${direction}`);
  }

  getFatDoctoCProjectionPageSearch(page?: number, size?: number,  search?: string, 
    order?: string, direction?: string): Observable<PageResult<FatDoctoCProjection>> {
    return this.http.get<PageResult<FatDoctoCProjection>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/projection/?page=${(page??1)<=0?1:page}&size=` +
    `${size}&search=${search}&order=${order}&direction=${direction}`);
  }

  getFatDoctoCModelosPage(modelos?: string, dataInicial?: Date, dataFinal?: Date, page?: number, size?: number,order?: string, direction?: string): Observable<PageResult<FatDoctoC>> {
    console.log(`modelo=${modelos}&page=${(page??1)<=0?1:page}&size=`);
    return this.http.get<PageResult<FatDoctoC>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/modelos?modelos=${modelos}&page=${(page??1)<=0?1:page}&size=`
     + `${size}&order=${order}&direction=${direction}&dataInicial=${dataInicial.toISOString()}&dataFinal=${dataFinal.toISOString()}`);
  }

  getFatDoctoCModelosPageSearch(modelos?: string, page?: number, size?: number,  search?: string, dataInicial?: Date, dataFinal?: Date,
    order?: string, direction?: string): Observable<PageResult<FatDoctoC>> {
    return this.http.get<PageResult<FatDoctoC>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/modelos?modelos=${modelos}&page=${(page??1)<=0?1:page}&size=` +
    `${size}&search=${search}&order=${order}&direction=${direction}&dataInicial=${dataInicial.toISOString()}&dataFinal=${dataFinal.toISOString()}`);
  }

  getFatDoctoCByTransacaoPage(transacaoIds: number | string, page?: number, size?: number): Observable<PageResult<FatDoctoC>> {
    const ids = Array.isArray(transacaoIds) ? transacaoIds.join(',') : transacaoIds.toString();
    return this.http.get<PageResult<FatDoctoC>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/transacao?transacaoIds=${ids}&page=${(page??1)<=0?1:page}&size=${size}`);
  }

  getFatDoctoCByTransacaoPageSearch(transacaoIds: number | string, search: string, page?: number, size?: number): Observable<PageResult<FatDoctoC>> {
    const ids = Array.isArray(transacaoIds) ? transacaoIds.join(',') : transacaoIds.toString();
    return this.http.get<PageResult<FatDoctoC>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/transacao?transacaoIds=${ids}&search=${search}&page=${(page??1)<=0?1:page}&size=${size}`);
  }

  // Lista doctos por tipo de operação (diretiva 122 / TipoOperacao). Usado pela Vendas-list:
  // filtra o contexto de venda de forma resistente a devolução (que troca a natureza mas mantém a operação).
  getFatDoctoCOperacaoPage(operacoes: string, dataInicial?: Date, dataFinal?: Date, page?: number, size?: number): Observable<PageResult<FatDoctoC>> {
    const periodo = (dataInicial && dataFinal)
      ? `&dataInicial=${dataInicial.toISOString()}&dataFinal=${dataFinal.toISOString()}`
      : '';
    return this.http.get<PageResult<FatDoctoC>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/operacao?operacoes=${operacoes}${periodo}&page=${(page??1)<=0?1:page}&size=${size}`);
  }

  getFatDoctoCOperacaoPageSearch(operacoes: string, search: string, page?: number, size?: number): Observable<PageResult<FatDoctoC>> {
    return this.http.get<PageResult<FatDoctoC>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/operacao?operacoes=${operacoes}&search=${search}&page=${(page??1)<=0?1:page}&size=${size}`);
  }

  getItem(controle: number, produtoId: number) : Observable<FatDoctoI>{
    return this.http.get<FatDoctoI>(`${this.jwtAuthService.apiUrl + this.path}/item/${controle}/${produtoId}`);
  }

  getExistsItem(controle: number, produtoId: number) : Observable<boolean>{
    return this.http.get<boolean>(`${this.jwtAuthService.apiUrl + this.path}/item/exist/${controle}/${produtoId}`);
  }

  getExistsLocalCarga(controle: number, cidadeId: number) : Observable<boolean>{
    return this.http.get<boolean>(`${this.jwtAuthService.apiUrl + this.path}/carga/exist/${controle}/${cidadeId}`);
  }

  getExistsUfPercurso(controle: number, cidadeId: number) : Observable<boolean>{
    return this.http.get<boolean>(`${this.jwtAuthService.apiUrl + this.path}/percuerso/exist/${controle}/${cidadeId}`);
  }

  getPageItem(controle: number, page?: number, size?: number, order?: string, direction?: string) : Observable<PageResult<FatDoctoI>>{
    return this.http.get<PageResult<FatDoctoI>>(`${this.jwtAuthService.apiUrl + this.path}/item/page/get/?page=${(page??1)<=0?1:page}&size=` +
    `${size}&controle=${controle}&order=${order ?? 'NENHUM'}&direction=${direction ?? 'ASC'}`);
  }

  getPageItemSearch(controle: number, page?: number, size?: number,
     search?: string, order?: string, direction?: string): Observable<PageResult<FatDoctoI>>{
    return this.http.get<PageResult<FatDoctoI>>(`${this.jwtAuthService.apiUrl + this.path}/item/page/get/?page=${(page??1)<=0?1:page}&size=` +
    `${size}&search=${search}&controle=${controle}&order=${order ?? 'NENHUM'}&direction=${direction ?? 'ASC'}`);
  }

  saveOrUpdateItem(item: FatDoctoI): Observable<FatDoctoI> {
    return this.http.put<FatDoctoI>(`${this.jwtAuthService.apiUrl + this.path}/item/web`, item);
  }

  addItem(item: FatDoctoI): Observable<any> {
    return this.http.put<any>(`${this.jwtAuthService.apiUrl + this.path}/item`, item);
  }

  deleteItem(controle: number, produtoId: number): Observable<any> {
    return this.http.delete<any>(`${this.jwtAuthService.apiUrl + this.path}/item/${controle}/${produtoId}`);
  }

  getItems(controle: number) : Observable<FatDoctoIProjection[]>{
    return this.http.get<FatDoctoIProjection[]>(`${this.jwtAuthService.apiUrl + this.path}/item/list/${controle}`);
  }


  getLog(uuid: string ): Observable<any> {
    return this.http.get<any>(`${this.jwtAuthService.apiUrl}/log/${uuid}`);
  }

  deleteLog(uuid: string ): Observable<any> {
    return this.http.delete<any>(`${this.jwtAuthService.apiUrl}/log/${uuid}`);
  }

  getDoctoRef(controle: number): Observable<FatDoctoRef[]> {
    return this.http.get<FatDoctoRef[]>(`${this.jwtAuthService.apiUrl + this.path}/ref/lista/${controle}/`);
  }

  getPageDoctoRef(controle: number, page?: number, size?: number, order?: string, direction?: string) : Observable<PageResult<FatDoctoRef>>{
    return this.http.get<PageResult<FatDoctoRef>>(`${this.jwtAuthService.apiUrl + this.path}/ref/page/get/?page=${(page??1)<=0?1:page}&size=` +
    `${size}&controle=${controle}&order=${order}&direction=${direction}`);
  }

  getPageSearchDoctoRef(search: string, controle: number, page: number, pageSize: number, selectedOrdem: string, selectedDirect: string)  : Observable<PageResult<FatDoctoRef>>{
    throw new Error('Method not implemented.');
  }

  createDoctoRef(): Observable<FatDoctoRef> {
    return this.http.post<FatDoctoRef>(`${this.jwtAuthService.apiUrl + this.path}/ref`, null)
  }

  saveOrUpdateDoctoRef(doctoRef: FatDoctoRef): Observable<FatDoctoRef> {
    return this.http.put<FatDoctoRef>(`${this.jwtAuthService.apiUrl + this.path}/ref`, doctoRef);
  }

  deleteDoctoRef(id: number): Observable<any> {
    return this.http.delete<any>(`${this.jwtAuthService.apiUrl + this.path}/ref/${id}`);
  }

  getDoctoAnttTipo(controle: number): Observable<FatDoctoAnttTipo[]> {
    return this.http.get<FatDoctoAnttTipo[]>(`${this.jwtAuthService.apiUrl + this.path}/antt/tipo/lista/${controle}/`);
  }

  getPageDoctoAnttTipo(controle: number, page?: number, size?: number, order?: string, direction?: string) : Observable<PageResult<FatDoctoAnttTipo>>{
    return this.http.get<PageResult<FatDoctoAnttTipo>>(`${this.jwtAuthService.apiUrl + this.path}/antt/tipo/page/get/?page=${(page??1)<=0?1:page}&size=` +
    `${size}&controle=${controle}&order=${order}&direction=${direction}`);
  }

  getPageSearchDoctoAnttTipo(search: string, controle: number, page: number, pageSize: number, selectedOrdem: string, selectedDirect: string)  : Observable<PageResult<FatDoctoAnttTipo>>{
    throw new Error('Method not implemented.');
  }

  createDoctoAnttTipo(): Observable<FatDoctoAnttTipo> {
    return this.http.post<FatDoctoAnttTipo>(`${this.jwtAuthService.apiUrl + this.path}/antt/tipo`, null)
  }

  saveOrUpdateDoctoAnttTipo(doctoRef: FatDoctoAnttTipo): Observable<FatDoctoAnttTipo> {
    return this.http.put<FatDoctoAnttTipo>(`${this.jwtAuthService.apiUrl + this.path}/antt/tipo`, doctoRef);
  }

  deleteDoctoAnttTipo(id: number): Observable<any> {
    return this.http.delete<any>(`${this.jwtAuthService.apiUrl + this.path}/antt/tipo/${id}`);
  }

  getDoctoLocalCarga(controle: number): Observable<FatDoctoLocalCarga[]> {
    return this.http.get<FatDoctoLocalCarga[]>(`${this.jwtAuthService.apiUrl + this.path}/carga/lista/${controle}/`);
  }

  deleteDoctoLocalCarga(localId: number): Observable<any> {
    return this.http.delete<any>(`${this.jwtAuthService.apiUrl + this.path}/carga/${localId}`);
  }

  getPageDoctoLocalCarga(controle: number, page?: number, size?: number, order?: string, direction?: string) : Observable<PageResult<FatDoctoLocalCarga>>{
    return this.http.get<PageResult<FatDoctoLocalCarga>>(`${this.jwtAuthService.apiUrl + this.path}/carga/page/get/?page=${(page??1)<=0?1:page}&size=` +
    `${size}&controle=${controle}`);
  }

  saveOrUpdateDoctoLocalCarga(controle: number, cidadeId: number): Observable<FatDoctoLocalCarga> {
    return this.http.put<FatDoctoLocalCarga>(`${this.jwtAuthService.apiUrl + this.path}/carga/save/${controle}/${cidadeId}`, null);
  }

  getDoctoUfPercurso(controle: number): Observable<FatDoctoUfPercurso[]> {
    return this.http.get<FatDoctoUfPercurso[]>(`${this.jwtAuthService.apiUrl + this.path}/percurso/lista/${controle}/`);
  }

  getPageDoctoUfPercurso(controle: number, page?: number, size?: number, order?: string, direction?: string) : Observable<PageResult<FatDoctoUfPercurso>>{
    return this.http.get<PageResult<FatDoctoUfPercurso>>(`${this.jwtAuthService.apiUrl + this.path}/percurso/page/get/?page=${(page??1)<=0?1:page}&size=` +
    `${size}&controle=${controle}`);
  }

  saveOrUpdateDoctoUfPercurso(controle: number, estadoId: number): Observable<FatDoctoUfPercurso> {
    return this.http.put<FatDoctoUfPercurso>(`${this.jwtAuthService.apiUrl + this.path}/percurso/save/${controle}/${estadoId}`, null);
  }

  saveOrUpdateDoctoUfDescarga(controle: number, uf: string): Observable<FatDoctoUfPercurso> {
    return this.http.put<FatDoctoUfPercurso>(`${this.jwtAuthService.apiUrl + this.path}/descarga/${controle}/${uf}`, null);
  }

  deleteDoctoUfPercurso(percursoId: number): Observable<any> {
    return this.http.delete<any>(`${this.jwtAuthService.apiUrl + this.path}/percurso/${percursoId}`);
  }

  getCartaCorrecao(controle: number): Observable<FatDoctoCCce[]> {
    return this.http.get<FatDoctoCCce[]>(`${this.jwtAuthService.apiUrl + this.path}/carta/correcao/lista/${controle}/`);
  }

  pdfCarta(id: number): Observable<any> {
    return this.http.get(`${this.jwtAuthService.apiUrl + this.path}/carta/correcao/print/${id}`, {responseType: 'arraybuffer' })
  }

  saveOrUpdateTransportador(lcto: any): Observable<FatDoctoC> {
    return this.http.put<FatDoctoC>(`${this.jwtAuthService.apiUrl + this.path}/transportador`, lcto);
  }


  saveOrUpdateAndRecalcFinancParcelas(financRp: FinancRp): Observable<FinancRp[]> {
    return this.http.put<FinancRp[]>(`${this.jwtAuthService.apiUrl + this.path}/recalc/parcelas`, financRp);
  }

  getFinancParcelas(fatura: number ): Observable<FinancRp[]> {
    return this.http.get<FinancRp[]>(`${this.jwtAuthService.apiUrl + this.path}/lista/parcelas/${fatura}`);
  }

  getAuthorizationProgress(controle: number): Observable<any> {
    return this.http.get<any>(`${this.jwtAuthService.apiUrl + this.path}/autoriza/progress/${controle}`);
  }



}
